module.exports = __webpack_public_path__ + "950a1b56e969820481f18f4ed044af52.pdf";